import { useState } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_FINANCE_PROGRAM_BY_ID } from '../api/getFinanceProgramById';
import { GET_FINANCE_PROGRAMS_OPTIONS } from '../api/getFinanceProgramOptions';
import { FinanceProgramByIdResponse, FinanceProgramOptionsResponse } from '../api';

interface Params {
  accountId: string;
}

export function useFetchSubsidyCalculatorData({ accountId }: Params) {
  const [selectedProgramId, setSelectedProgramId] = useState<string>('');

  const { data: optionsData, loading: isOptionsLoading } = useQuery<FinanceProgramOptionsResponse>(
    GET_FINANCE_PROGRAMS_OPTIONS,
    { variables: { accountId } }
  );

  const [fetchProgram, { data: programData, loading: isProgramLoading }] =
    useLazyQuery<FinanceProgramByIdResponse>(GET_FINANCE_PROGRAM_BY_ID);

  const selectProgram = (programId: string) => {
    setSelectedProgramId(programId);
    if (programId) {
      fetchProgram({ variables: { financeProgramId: programId } });
    }
  };

  return {
    selectedProgramId,
    programOptions: optionsData?.options ?? [],
    isOptionsLoading,
    isProgramLoading,
    financeProgram: programData?.financeProgram ?? null,
    selectProgram,
  };
}
